import { createAsyncThunk } from "@reduxjs/toolkit";

import { EndPoints } from "../../api/endpoints";
import axiosClient from "../../api/axiosClient";

export type AddCategory = {
  name: string;
  icon: string;
};

export type UpdateCategory = {
  id: string;
  name: string;
  icon: string;
};

export const getSupportTickets = createAsyncThunk(
  "getSupportTickets",
  async (_, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(EndPoints.supportTickets);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const addSupport = createAsyncThunk(
  "createSupportTicket",
  async (data: AddCategory, { dispatch, rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.put(EndPoints.categories, data);
      dispatch(getSupportTickets());
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const updateSupport = createAsyncThunk(
  "updateSupport",
  async (data: UpdateCategory, { dispatch, rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.patch(
        `${EndPoints.categories}/${data.id}`,
        data
      );
      dispatch(getSupportTickets());
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const deleteSupport = createAsyncThunk(
  "deleteSupport",
  async (id: string, { dispatch, rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.delete(
        `${EndPoints.categories}/${id}`
      );
      dispatch(getSupportTickets());
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);
